import { useCallback, useEffect, useRef, useState } from "react";

export default function useDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  //알림 드랍다운 열려있을시 외부 클릭하면 닫기
  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      const target = event.target as Node;
      const dropdown = dropdownRef.current;
      const button = buttonRef.current;

      const isClickOutsideDropdown = !dropdown?.contains(target);
      const isClickOutsideButton = isOpen && !button?.contains(target);

      if (isOpen && isClickOutsideDropdown) {
        setIsOpen(false);
      } else if (isClickOutsideButton && !isClickOutsideDropdown) {
        if (button?.contains(target)) {
          setIsOpen(false);
        }
      }
    },
    [isOpen, dropdownRef, buttonRef]
  );

  useEffect(() => {
    window.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);
  return { isOpen, setIsOpen, dropdownRef, buttonRef };
}
